import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import FormRow from "../ui/uiElements/FromRow.component";
import { Link } from "react-router-dom";
import AuthCard from "../ui/uiElements/AuthCard.component";
import { useLogin } from "../hooks/useLogin";

function Login() {
  const { register: formRegister, formState, handleSubmit } = useForm();
  const { errors } = formState;
  const { login, isLoading } = useLogin();

  const handleLogin = ({ email, password, rememberMe }) => {
    login({
      email,
      password,
      rememberMe: !!rememberMe,
    });
  };

  return (
    <AuthCard title="LOGIN TO YOUR ACCOUNT">
      <Form onSubmit={handleSubmit(handleLogin)}>
        <FormRow label="Email" error={errors?.email?.message}>
          <Form.Control
            className=" bg-light rounded border border-secondary border-opacity-50 "
            type="email"
            id="email"
            placeholder="Enter Email"
            disabled={isLoading}
            {...formRegister("email", {
              required: "This field is required",
              pattern: {
                value: /\S+@\S+\.\S+/,
                message: "Please provide a valid email address",
              },
            })}
          />
        </FormRow>
        <FormRow label="Password" error={errors?.password?.message}>
          <Form.Control
            className=" bg-light rounded border border-secondary border-opacity-50 "
            type="password"
            id="password"
            placeholder="Enter Password"
            disabled={isLoading}
            {...formRegister("password", {
              required: "This field is required",
              minLength: {
                value: 6,
                message: "Password needs a minimum of 6 characters",
              },
            })}
          />
        </FormRow>

        <div className="p-2 d-flex justify-content-between align-items-center">
          <Form.Check
            type="checkbox"
            id="rememberMe"
            label="Keep me logged in"
            disabled={isLoading}
            defaultChecked
            {...formRegister("rememberMe")}
          />
          <Link to="/reset-password" className="text-body">
            Forgot password?
          </Link>
        </div>

        <div className="d-flex justify-content-center">
          <button className="w-100  btn btn-success mt-3 btn-lg text-white" type="submit" disabled={isLoading}>
            Login
          </button>
        </div>
        <p className="text-center text-muted mt-5 mb-0">
          You dont have account?{" "}
          <Link to="/register" className="fw-bold text-body">
            <u>signup here</u>
          </Link>
        </p>
      </Form>
    </AuthCard>
  );
}

export default Login;
